import { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useGetLatestTimeSheetByWorker } from '../projects/hooks'

export const SelectTimeSheet = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { id } = useParams()
  const workerId = location.state ? location.state.worker : null
  const { data: timesheet, isFetching } = useGetLatestTimeSheetByWorker(
    'timecards',
    workerId
  )

  useEffect(() => {
    if (!isFetching && timesheet) {
      navigate(`/projects/${id}/timecard/${workerId}/out/${timesheet._id}`)
    } else if (!isFetching) {
      navigate(`/projects/${id}/timecard/${workerId}/in`)
    }
  }, [timesheet, isFetching, navigate, id, workerId])

  if (isFetching) {
    ;<>Fetching...</>
  }
  return <>Fetching...</>
}
